module.exports = "<header class=\"navbar navbar-fixed-top\">\n  <div class=\"container\">\n    <nav class=\"navbar\">\n      <a class=\"navbar-brand\" href=\"/\">\n        <img src=\"/assets/images/logo-vw.svg\" alt=\"Volkswagen logo\">\n      </a>\n\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li class=\"logout-button\">\n          <a (click)=\"logout()\">{{'btn-logout' | translate}}</a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.html
// module id = ./src/app/shared/header/header.component.html
// module chunks = main